export default (client) => {
  return {
    search(query, config = {}) {
      return client.get('/geocoding/search/', { params: { query }, ...config })
    },
  }
}
